import React from "react";

function Hero() {
  return (
    <section
      style={{
        backgroundColor: "#007bff",
        color: "white",
        textAlign: "center",
        padding: "50px 20px",
      }}
    >
      <h1 style={{ fontSize: "2.5rem" }}>Welcome to GracePresenter</h1>
      <p style={{ fontSize: "1.2rem", marginTop: "10px" }}>
        A modern solution for Bible and Song presentations.
      </p>
    </section>
  );
}

export default Hero;
